import "UI/Widget/Form";
NS("Glonass.UI");

Glonass.UI.Footer = Class(UI.Widget.Base, {
    template: "Glonass/Footer",
    switchTemplate: "Glonass/FooterSwitch",

    $switches: null,
    switches: [],

    render: function() {
        this.ParentCall();

        this.$switches = this.$name("switches");

        UI.Widget.Form.on("Switchable.Register", this.onSwitchableRegister, this);
        UI.Widget.Form.on("Switchable.Unregister", this.onSwitchableUnregister, this);
        UI.Widget.Form.on("Switchable.Pop", this.onSwitchablePop, this);

        return this;
    },

    onSwitchableRegister: function(args) {
        var widget = args.widget;

        var $switch = UI.Template.$render(this.switchTemplate, {
            title: widget.getTitle()
        }).appendTo(this.$switches);

        this.switches.push({
            widget: widget,
            switch: $switch[0]
        });

        widget.on("title", this.onWidgetTitle, this);
    },

    onSwitchableUnregister: function(args) {
        var widget = args.widget;

        for (var i = 0; i < this.switches.length; i++) {
            if (this.switches[i].widget == widget) {
                $(this.switches[i].switch).remove();
                this.switches.splice(i, 1);
                break;
            }
        }
    },

    onSwitchablePop: function(args) {
        var widget = args.widget;

        this.$(".gl-footer__switch_item").removeClass("active");

        for (var i = 0; i < this.switches.length; i++) {
            if (this.switches[i].widget == widget) {
                $(this.switches[i].switch).addClass("active");
                break;
            }
        }
    },

    onSwitchClick: function(caller) {
        for (var i = 0; i < this.switches.length; i++) {
            if (this.switches[i].switch == caller) {
                UI.Widget.Form.popSwitchable(this.switches[i].widget);
                break;
            }
        }
    },

    onCloseClick: function(caller, args) {
        for (var i = 0; i < this.switches.length; i++) {
            if (this.switches[i].switch == caller) {
                this.switches[i].widget.destroy();
                break;
            }
        }

        args.preventDefault();
    },

    onWidgetTitle: function(args, emitter) {
        for (var i = 0; i < this.switches.length; i++) {
            if (this.switches[i].widget == emitter) {
                $(this.switches[i].switch).text(args.title);
                break;
            }
        }
    }
});
